/* istanbul ignore file */
import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";
import { rootRouteRef } from "./routes";

export const compensationForgePlugin = createPlugin({
  id: "compensation-forge",
  routes: {
    root: rootRouteRef,
  },
});

export const CompensationForgePage = compensationForgePlugin.provide(
  createRoutableExtension({
    name: "CompensationForgePage",
    component: () =>
      import("./components/CompensationForgeComponent").then(
        (m) => m.CompensationForgeComponent as () => JSX.Element
      ),
    mountPoint: rootRouteRef,
  })
);
